module.exports = __webpack_public_path__ + "img/formulaPR.67ebcc66.svg";